module.exports = __webpack_public_path__ + "static/media/icon_trash.0d926f11.svg";